import { OrderPublicStatus, OrderStatus } from '~/api/Order';
import { OrdersTab } from '~/pages/Orders/interfaces';

export const ORDERS_TAB_STATUSES: Record<
  OrdersTab,
  (OrderStatus | OrderPublicStatus)[]
> = {
  [OrdersTab.ACTIVE]: [
    'accepted',
    'picking',
    'wh_created',
    'confirmed',
    'delivery_created',
    'ready_to_ship',
    'ready_for_pickup',
    'in_delivery',
  ],
  [OrdersTab.HISTORY]: [
    'delivered',
    'delivered_partially',
    'finished',
    'cancelled',
  ],
};
